export const translationEngDefault = {
    SkhemataBlogCategories: {
        categoriesTitle: 'Categories',
        allCategories: 'All Categories',
    }
};
//# sourceMappingURL=eng.js.map